import { type OrderItem } from '@hooks-api/types/dataModel/fpOrder'
import { type WpSubshipSetting } from '@hooks-api/types/dataModel/wp'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { NoTrackingNumber } from './NoTrackingNumber'
import { OrderItems } from './OrderItems'

interface NoShipmentOrderItemsProps {
  orderItems: OrderItem[]
  index?: number
  isPendingOrder: boolean
  subshipType?: WpSubshipSetting['type']
}

export function NoShipmentOrderItems({ orderItems, index, isPendingOrder, subshipType }: NoShipmentOrderItemsProps) {
  const { t } = useTranslation()
  return (
    <Paper p={3}>
      <VStack gap={3}>
        {!isPendingOrder && (
          <>
            <Text variant="subtitle">
              {`${t('orderDetail.shipmentOrder', { defaultValue: '出貨項目' })}${index != null ? ` ${index}` : ''}`}
            </Text>
            <NoTrackingNumber />
          </>
        )}
        <OrderItems orderItems={orderItems} subshipType={subshipType} />
      </VStack>
    </Paper>
  )
}
